import {
  InfoAccordion,
  InfoItem,
} from "components/ChannelinfoSlider/ChannelinfoSlider";
import { useEffect, useMemo, useState } from "react";
import { ChannelMemberResponse } from "stream-chat";
import {
  DefaultStreamChatGenerics,
  useChannelStateContext,
} from "stream-chat-react";

export const TeamMembersForCustomer = () => {
  const { channel } = useChannelStateContext();
  const founderRoles = ["Inkle CEO", "Inkle CTO"];
  const supportRoles = ["Inkle Admin", "Admin", "Support"];
  const memberIds = useMemo(
    () => Object.keys(channel?.state?.members || {}),
    [channel?.state?.members]
  );

  const { founders, supports } = useMemo(() => {
    const members = Object.values(channel?.state?.members || {});
    const groupedMembers = {
      founders: [] as ChannelMemberResponse<DefaultStreamChatGenerics>[],
      supports: [] as ChannelMemberResponse<DefaultStreamChatGenerics>[],
    };

    members.forEach((member) => {
      if (founderRoles.includes(member.user?.role_name as string)) {
        groupedMembers.founders.push(member);
      } else if (supportRoles.includes(member.user?.role_name as string)) {
        groupedMembers.supports.push(member);
      }
    });

    return groupedMembers;
  }, [memberIds]);

  return (
    <InfoItem
      title="TEAMS"
      value={
        <div className="t-flex t-flex-col t-gap-3">
          <InfoAccordion members={founders} title="Founders" />
          <InfoAccordion members={supports} title="Support" />
        </div>
      }
    />
  );
};
